<template>
  <div>
    <a
      class="ag-nomal-action-menu"
      href="javascript:void(0);"
      @click="deleteTechStatus"
    >
      <i class="material-icons-outlined align-middle">delete</i>
    </a>
  </div>
</template>

<script>
export default {
  methods: {
    deleteTechStatus: function () {
      this.params.context.componentParent.deleteTechStatus(this.params.data);
    },
  },
};
</script>
